export default "__VITE_ASSET__Bc4P9RM$__"